export const AUTHORIZE_TYPE = {
  BASIC: "BASIC",
  OAUTH: "OAUTH",
  PERSONAL_ACCESS_TOKEN: "PERSONAL_ACCESS_TOKEN",
};

export type JiraLoginConfigType = {
  configCount?: number;
  consumerKey?: string | null;
  email?: string;
  hostUrl?: string;
  id?: number;
  loginType?: string;
  name?: string;
  ticketSystemType?: string;
  tokenType?: string;
  url?: string;
  userName?: string;
  version?: string;
  userType?: string;
};

export type JiraIntegrationConfigLoginFormPropsType = {
  name: string;
  loginConfigList: JiraLoginConfigType[];
  handleMapping?: (response: JiraLoginConfigType) => void;
  config: JiraLoginConfigType;
  onUpdateConfigComponent?: (param: boolean) => void;
  afterClose?: () => void;
};

export const CONFIG_TYPE_TAB = {
  JIRA_CLOUD: "Jira Cloud",
  JIRA_DATA_CENTER: "Jira Data Center",
};

export const USER_CONFIG_TYPE = {
  REGULAR: "REGULAR",
  SERVICE_ACCOUNT: "SERVICE_ACCOUNT",
};

export const ON_PREM_RADIO_OPTIONS = [
  {
    value: AUTHORIZE_TYPE.BASIC,
    label: "Basic Auth",
  },
  {
    value: AUTHORIZE_TYPE.OAUTH,
    label: "OAuth",
  },
  {
    value: AUTHORIZE_TYPE.PERSONAL_ACCESS_TOKEN,
    label: "Personal Access Token",
  },
];
export const CLOUD_RADIO_OPTIONS = [
  {
    label: "Token Auth",
    value: USER_CONFIG_TYPE.REGULAR,
  },
  {
    label: "Service Account / Scoped Token Auth",
    value: USER_CONFIG_TYPE.SERVICE_ACCOUNT,
  },
];

export const RADIO_OPTION_TAB_MAP = {
  [CONFIG_TYPE_TAB.JIRA_CLOUD]: CLOUD_RADIO_OPTIONS,
  [CONFIG_TYPE_TAB.JIRA_DATA_CENTER]: ON_PREM_RADIO_OPTIONS,
};
